class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.boundClose = this.close.bind(this);
    this.addEventListener('keyup', (e) => e.key === 'Escape' && this.close());
    this.bindInner();
    this.setHeaderCartLink();
  }

  setHeaderCartLink() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open();
    });
  }

  open() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    if (parsedState.sections['cart-drawer']) {
      const inner = this.querySelector('.drawer__inner');
      const fresh = new DOMParser()
        .parseFromString(parsedState.sections['cart-drawer'], 'text/html')
        .querySelector('.drawer__inner');
      if (inner && fresh) {
        inner.replaceWith(fresh);
        this.bindInner();
      }
    }

    if (parsedState.sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const freshBubble = new DOMParser()
        .parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    }

    this.open();
  }

  bindInner() {
    // boundClose is the same function reference every time, so re-binding
    // after a re-render cannot stack duplicate listeners on the overlay
    const overlay = this.querySelector('.drawer__overlay');
    if (overlay) overlay.addEventListener('click', this.boundClose);
    this.querySelectorAll('[data-drawer-close]').forEach((b) =>
      b.addEventListener('click', this.boundClose)
    );
  }

}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce(this.onChange.bind(this), 300));
    this.querySelectorAll('[data-cart-remove]').forEach((link) =>
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.updateQuantity(link.dataset.index, 0);
      })
    );
  }

  onChange(event) {
    if (!event.target.matches('[data-quantity-input]')) return;
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  updateQuantity(line, quantity) {
    this.classList.add('is-loading');
    const body = JSON.stringify({
      line,
      quantity: Number(quantity),
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((state) => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections && state.sections['cart-drawer']) {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(() => window.location.reload())
      .finally(() => this.classList.remove('is-loading'));
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

/* Cart page items -------------------------------------------------------- */
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce(this.onChange.bind(this), 300));
    this.querySelectorAll('[data-cart-remove]').forEach((link) =>
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.updateQuantity(link.dataset.index, 0);
      })
    );
  }

  onChange(event) {
    if (!event.target.matches('[data-quantity-input]')) return;
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  updateQuantity(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity: Number(quantity),
      sections: ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });
    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((r) => r.json())
      .then((state) => {
        ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'].forEach((name) => {
          const el = document.getElementById(name);
          if (!el || !state.sections || !state.sections[name]) return;
          const parsed = new DOMParser().parseFromString(state.sections[name], 'text/html');
          // cart-icon-bubble renders no inner id of its own - take the section wrapper
          const source = parsed.getElementById(name) || parsed.querySelector('.shopify-section');
          if (source) el.innerHTML = source.innerHTML;
        });
        if (state.item_count === 0) window.location.reload();
      })
      .catch(() => window.location.reload());
  }
}
customElements.define('cart-items', CartItems);
